import { Storage } from "@ionic/storage-angular";
import { TOKEN_KEY } from "src/app/shared/constants";
import { environment } from "src/environments/environment";


export function jwtOptionsFactory(storage: Storage) {
  return {
    tokenGetter: async () => {
      return await storage.get(TOKEN_KEY);
    },
    allowedDomains: environment.JWT_ALLOWED_DOMAINS,
    disallowedRoutes: [],
  }
}